module.exports = "/_next/static/images/mugitoolive_tsukemen-b06c4365f90c1831656957fc68e18f80.jpg";